module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var room = tour.get('room');
	var beds = room.beds;
	var standardName = room.standardName;
	var roomName = room.name;
	var roomDescription = room.description;
	var roomPhotos = room.photos;
	var touristGroup = tour.get('touristGroup');

__p+='\r\n<div class="roomInfoDg__container">\r\n	<div class="roomInfoDg__content">\r\n		<div class="roomInfoDg__gallery">\r\n			';
 if(roomPhotos && roomPhotos.length) { 
__p+='\r\n				<div class="slider-pro">\r\n					<div class="sp-slides">\r\n						';
 _.each(roomPhotos, function(photo) { 
__p+='\r\n							<div class="sp-slide">\r\n								<img src="' + require("/app/node_modules/underscore-template-loader/file-loader.js?url=.%2Fimg%2FroomInfoDg__gallery.gif!./img/roomInfoDg__gallery.gif") + '" alt="" class="sp-image" data-src="'+
((__t=( imageProxy(photo,{width:1920,height:1080})))==null?'':__t)+
'">\r\n							</div>\r\n						';
 }); 
__p+='\r\n					</div>\r\n					<div class="sp-thumbnails">\r\n						';
 _.each(roomPhotos, function(photo) { 
__p+='\r\n							<img src="' + require("/app/node_modules/underscore-template-loader/file-loader.js?url=.%2Fimg%2FroomInfoDg__gallery.gif!./img/roomInfoDg__gallery.gif") + '" alt="" class="sp-thumbnail" data-src="'+
((__t=( imageProxy(photo,{width:102,height:74}) ))==null?'':__t)+
'">\r\n						';
 }); 
__p+='\r\n					</div>\r\n				</div>\r\n			';
 } 
__p+='\r\n		</div>\r\n\r\n		<div class="roomInfoDg__description">\r\n			<div class="roomInfoDg__description-title">'+
((__t=( standardName || roomName ))==null?'':__t)+
'</div>\r\n			';
 if (beds) {
__p+='\r\n				<div class="roomInfoDg__description-sub-title">'+
((__t=( beds ))==null?'':__t)+
'</div>\r\n			';
 } 
__p+='\r\n			';

			if(roomDescription) { 
__p+='\r\n				<div class="roomInfoDg__description-header">Описание номера</div>\r\n				<div class="roomInfoDg__description-info">'+
((__t=( roomDescription ))==null?'':__t)+
'</div>\r\n			';
 } 
__p+='\r\n		</div>\r\n	</div>\r\n	<div class="roomInfoDg__info">\r\n		<div class="roomInfoDg__info-content">\r\n			<div>\r\n				<div class="roomInfoDg__meal">'+
((__t=( tour.get('meal').get('name') ))==null?'':__t)+
',</div>\r\n				<div class="roomInfoDg__tourists">'+
((__t=( adultsText + kidsText ))==null?'':__t)+
'</div>\r\n			</div>\r\n			<div class="roomInfoDg__planes">\r\n				<div class="roomInfoDg__plane">\r\n					<i class="icon-i32_plane"></i> '+
((__t=( datetimeForward))==null?'':__t)+
'\r\n				</div>\r\n				<div class="roomInfoDg__plane">\r\n					<i class="icon-i32_plane scale"></i> '+
((__t=( datetimeBackward))==null?'':__t)+
'\r\n				</div>\r\n			</div>\r\n			<div>\r\n				<div class="roomInfoDg__nights">'+
((__t=( "на " + nights + " " + nights.wordEnding('ночь;ночи;ночей')))==null?'':__t)+
'</div>\r\n				';
 if(tour.get('flightType') === 2) { 
__p+='\r\n					<div class="roomInfoDg__regular">есть регулярные рейсы</div>\r\n				';
 } 
__p+='\r\n			</div>\r\n		</div>\r\n\r\n		<div class="roomInfoDg__price-block">\r\n			<div class="roomInfoDg__price-sale">\r\n				';
 if(tour.get('percentValue')) { 
__p+='\r\n				<span class="roomInfoDg__price-sale__percent">Предоплата <strong>'+
((__t=( (tour.get('percentValue') * 100).formatNumber() ))==null?'':__t)+
'%</strong></span>\r\n				<p>'+
((__t=( (tour.get('priceWithOilTax') * tour.get('percentValue')).formatNumber() ))==null?'':__t)+
' руб.  и тур ваш!</p>\r\n				';
 } else if(tour.get('discount') > 0.1) { 
__p+='\r\n				<span>Скидка - '+
((__t=( (tour.get('discount') * 100).formatNumber()))==null?'':__t)+
'%</span>\r\n				<p><s>'+
((__t=( tour.get('originalPrice').formatNumber() ))==null?'':__t)+
' руб.</s></p>\r\n				';
 } 
__p+='\r\n			</div>\r\n			<div class="roomInfoDg__price-block__btn js-go-to-tour-page">\r\n				от '+
((__t=( tour.get('priceWithOilTax').formatNumber() ))==null?'':__t)+
' руб.\r\n				';
 if(tour.get('oilTaxIsAbsent')) {
__p+='\r\n				<span>узнать топл. сбор</span>\r\n				';
} else{
__p+='\r\n				<span>вкл. топл сбор: '+
((__t=( tour.get('oilTax').formatNumber() ))==null?'':__t)+
' руб.</span>\r\n				';
}
__p+='\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>';
}
return __p;
};
